export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-orkut-f1302ee2f7ce46615aff30ac32f25885.svg";